var React = require('react');

function Infinity (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.5 5c-.473-.946-1.17-1.892-1.958-2.785C5.28-.35 1.5 1.58 1.5 5h0c0 3.42 3.78 5.35 6.042 2.785C8.33 6.892 9.027 5.946 9.5 5zm0 0c.473.946 1.17 1.892 1.957 2.785C13.72 10.35 17.5 8.42 17.5 5h0c0-3.42-3.78-5.35-6.042-2.785C10.67 3.108 9.973 4.054 9.5 5z","stroke":"#f6a000","strokeWidth":"2"}));
}

Infinity.defaultProps = {"width":"19","height":"10","fill":"none","xmlnsV":"https://vecta.io/nano"};

module.exports = Infinity;

Infinity.default = Infinity;
